import type { ReactNode } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { Line } from '@/components/elements/Line'
import { Spacer } from '@/components/elements/Spacer'
import { AHeading } from '@/components/enlayouts/Ir/Heading'

type QuestionListProps = {
  questionTitle: string
  questionList: {
    id: string
    questionContent: ReactNode
    answerContent: ReactNode
  }[]
}

export const QuestionList = ({
  questionTitle,
  questionList,
}: QuestionListProps) => {
  return (
    <>
      <AHeading>{questionTitle}</AHeading>
      {questionList.map(({ id, questionContent, answerContent }, index) => (
        <ul key={id}>
          <QuestionContent>
            <FaqFront>
              <QuestionIcon>Q</QuestionIcon>
            </FaqFront>
            <p>{questionContent}</p>
          </QuestionContent>
          <Spacer h={{ sp: 16, pc: 20 }} />
          <AnswerContent>
            <FaqFront>
              <AnswerIcon>A</AnswerIcon>
            </FaqFront>
            <p>{answerContent}</p>
          </AnswerContent>
          <Spacer h={{ sp: 20, pc: 44 }} />
          {index === questionList.length - 1 ? (
            <Spacer h={{ sp: 70, pc: 100 }} />
          ) : (
            <>
              <Line color="greyBlue" weight={1} direction="horizon" />
              <Spacer h={{ sp: 20, pc: 44 }} />
            </>
          )}
        </ul>
      ))}
    </>
  )
}

const QuestionContent = styled.li`
  display: flex;
  gap: 10px;

  p {
    font-size: 18px;
    line-height: 1.4;
    color: ${theme.colors.trialBlue};
    font-weight: 700;
  }

  @media screen and (max-width: 1047px) {
    p {
      font-size: 16px;
      line-height: 1.3;
    }
  }
`
const AnswerContent = styled.li`
  display: flex;
  gap: 10px;

  p {
    font-size: 16px;
    line-height: 1.9;
  }

  p > a {
    color: ${theme.colors.trialBlue};
    text-decoration: underline;
  }

  @media screen and (max-width: 1047px) {
    p {
      font-size: 15px;
      line-height: 1.6;
    }
  }
`

const FaqFront = styled.div`
  display: flex;
`

const QuestionIcon = styled.div`
  background: ${theme.colors.trialBlue};
  color: white;
  font-family: 'Rubik';
  font-style: normal;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 20px;
`
const AnswerIcon = styled.div`
  background: #b5bdc4;
  color: white;
  font-family: 'Rubik';
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 20px;
`
